export default () => (
  <div className="text-center">
    <span className="fa fa-spinner fa-pulse fa-3x" />
  </div>
);
